"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subscription = void 0;
const validation_1 = require("../../validation");
const subscription_details_1 = require("./subscription-details");
const misc_1 = require("../../misc");
const email_1 = require("../../misc/email");
/**
 * Subscription schema and validator function
 * @alpha
 */
var Subscription;
(function (Subscription) {
    Subscription.schema = {
        type: 'object',
        required: ['address', 'details'],
        properties: {
            address: misc_1.EthAddress.schema,
            email: Object.assign(Object.assign({}, email_1.Email.schema), { nullable: true }),
            details: subscription_details_1.SubscriptionDetails.schema
        }
    };
    Subscription.validate = (0, validation_1.generateLazyValidator)(Subscription.schema);
})(Subscription = exports.Subscription || (exports.Subscription = {}));
//# sourceMappingURL=subscription.js.map